import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

  if (!dsn) {
    console.log(`Sentry DSN not found for environment: ${environment}. Error tracking is disabled.`);
    return;
  }

  Sentry.init({
    dsn,
    environment,

    beforeSend(event) {
      if (event.request) {
        delete event.request.cookies;
      }

      if (event.exception?.values) {
        event.exception.values = event.exception.values.map(value => ({
          ...value,
          value: value.value?.replace(/\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi, '[REDACTED_EMAIL]')
            .replace(/\b\d{10,}\b/g, '[REDACTED_NUMBER]')
        }));
      }

      return event;
    },

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      'Network request failed',
      'NetworkError',
      'Failed to fetch',
      'Load failed',
      'cancelled',
    ],

    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],
  });
};

export const setSentryUser = (user) => {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
  });
};

export const setSentryContext = (context, data) => {
  Sentry.setContext(context, data);
};

export const addSentryBreadcrumb = (breadcrumb) => {
  Sentry.addBreadcrumb(breadcrumb);
};

export const captureSentryException = (error, context = {}) => {
  Sentry.captureException(error, {
    contexts: context,
  });
};

export const captureSentryMessage = (message, level = 'info') => {
  Sentry.captureMessage(message, level);
};

export default Sentry;
